export const QUIZZES_COLL = 'quizzes';

